import { IMask } from 'react-imask';

export const formattedNumberMask: IMask.AnyMaskedOptions = {
  mask: Number,
  scale: 0,
  signed: false,
  thousandsSeparator: ',',
};
